import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Require } from '~/app/require';
import { AppShell } from '~/components/shell/app-shell';

/**
 * Every page of a business: the shell around it, for a signed-in person
 * holding one. OS's live call is held above this gate (`routes/__root.tsx`),
 * so a Layout switch keeps it going and so does the `/v1/me` reload after a
 * setup's Create (step 5.2).
 */
export const Route = createFileRoute('/_app')({
  component: () => (
    <Require allow={['signed-in']}>
      <AppShell>
        <Outlet />
      </AppShell>
    </Require>
  ),
});
